import React from 'react'
import styles from './styles/btn-secondary.module.scss'
import classNames from 'classnames'

interface Props {
  onClick?: () => any
  size: 'small' | 'medium' | 'large'
  className?: string
  isDisabled?: boolean
  fullWidthAtMobile?: boolean
  href?: string
}

/**
 * WTN secondary button
 */

const BtnSecondary: React.FC<Props> = ({
  onClick,
  children,
  size,
  className,
  isDisabled = false,
  fullWidthAtMobile = false,
  href,
}) => {
  if (href)
    return (
      <a
        className={classNames(styles.secondaryBtn, styles[size || ''], className, {
          [styles.disabled]: isDisabled,
          [styles.fullWidthAtMobile]: fullWidthAtMobile,
        })}
        href={href}
      >
        {children}
      </a>
    )

  return (
    <button
      type='button'
      className={classNames(styles.secondaryBtn, styles[size], className, {
        [styles.disabled]: isDisabled,
        [styles.fullWidthAtMobile]: fullWidthAtMobile,
      })}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </button>
  )
}

export default BtnSecondary
